<template>
    <div>
      <div class="padding-bottom-sm" id="changProduct"
        style="float: left; width: 200px;max-height: calc(100vh - 125px);overflow-y: scroll;">
        <div style=" margin-bottom: 10px">
            <span style="font-size: 20px; color: rgb(8, 161, 184); font-weight: 800">丨模板选择</span>
          </div>
        <el-tree :data="treeList" node-key="id" :default-expanded-keys="defaultExpandKeys" :props="defaultProps"
          @node-click="handleNodeClick"></el-tree>
      </div>
      <!-- 内容 -->
      <div style="float: right; width: calc(100% - 230px)">
        <div v-if="detailsStatus == 1">
          <div style="text-align: center; margin-bottom: 10px">
            <span style="font-size: 20px; color: rgb(8, 161, 184); font-weight: 800">{{ treeNode.label }}模板设置</span>
            <i style="margin-left: 5px; cursor: pointer" class="el-icon-circle-plus-outline" @click="add"></i>
            <div style="float: right">
              <el-switch v-model="old"> </el-switch>
              {{ old ? "旧版" : "新版" }}
            </div>
          </div>
          <!-- 表格 -->
          <vxe-table :data="list" border size="mini">
            <vxe-column fixed="left" width="60" type="seq" title="序号" align="center"></vxe-column>
            <vxe-column title="模板标题" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sysPrintName }}</span>
              </template>
            </vxe-column>
            <vxe-column title="模板类型" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sysPrintType }}</span>
              </template>
            </vxe-column>
            <vxe-column title="顺序" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.orderNum }}</span>
              </template>
            </vxe-column>
            <vxe-column title="默认" align="center">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isDefault" :active-value="0" :inactive-value="1"
                  @change="saveRowData(scope.row)">
                </el-switch>
              </template>
            </vxe-column>
            <vxe-column title="操作" align="center" width="100">
              <template slot-scope="scope">
                <span class="text-olive pointer" @click="detailsGo(scope.row)">详情</span>
                <span class="text-red pointer margin-left-sm" @click="delModule(scope.row)">删除</span>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
        <div v-else>
          <table class="table">
            <tr>
              <td class="tableTitle">
                <div>模板标题</div>
              </td>
              <td>
                <el-input placeholder="请填写模板标题" size="small" v-model="singleData.sysPrintName"></el-input>
              </td>
            </tr>
            <tr>
              <td class="tableTitle">
                <div>模板类型</div>
              </td>
              <td>
                <el-input placeholder="请填写模板类型" size="small" v-model="singleData.sysPrintType"></el-input>
              </td>
            </tr>
            <tr>
              <td class="tableTitle">
                <div>顺序</div>
              </td>
              <td>
                <el-input placeholder="请填写顺序" size="small" type="number" v-model="singleData.orderNum"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <editor v-model="singleData.printTemplateDetails"></editor>
              </td>
            </tr>
            <tr>
              <td class="tableTitle">
                <div>打印变量</div>
              </td>
              <td>
                <div>
                  ============================================================================
                </div>
                <div>说明变量</div>
                <div>
                  ============================================================================
                </div>
                <div v-for="(item, index) in printSingleList" :key="index">
                  {#{{ item.name }}}
                </div>
                <div>
                  ============================================================================
                </div>
                <div v-for="(item, index) in printKeyList" :key="index">
                  {${{ item.name }}}
                </div>
                <div>
                  ============================================================================
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div style="text-align: center">
                  <el-button size="small" @click="saveClick()" style="width: 200px">提交</el-button>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div style="clear: both"></div>
  
      <!-- <print-page></print-page> -->
      <!-- <vue-easy-print style="display: none" tableShow ref="easyPrint">
        <div id="printArea" v-html="htmlData"></div>
      </vue-easy-print> -->
      <el-dialog :visible.sync="dialogState.show1" :close-on-click-modal="false" class="dialog" :title="'测试打印'" width="50%"
        @close="dialogClose">
        <vue-easy-print tableShow ref="easyPrint">
          <div v-html="htmlData"></div>
        </vue-easy-print>
        <el-button @click="dayin()">打印</el-button>
      </el-dialog>
    </div>
  </template>
<script>
import {
  sysPrint_add,
  sysPrint_update,
  sysPrint_list, sysPrint_delete,
  sysPrint_setDefault
} from '@/api/myController/system';
import vueEasyPrint from 'vue-easy-print';
import printPage from '@/components/print/print.vue';
//   import template from './template';
import treeList from './print-data';
import json from 'highlight.js/lib/languages/json';
export default {
  name: 'print_template',
  components: { vueEasyPrint, printPage },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getList(); // 执行方法
    });
  },
  data() {
    return {
      dialogState: {
        show1: false
      },
      // ...template,
      htmlData: `<table
          style="width: 100%; border-collapse: collapse"
          border="1"
          cellspacing="0"
          cellpadding="2"
          id="printTable"
        >
          <tbody>
            <tr>
              <td style="text-align: center">
                <span style="font-size: 16px">序号</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">产品编号</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">产品名称</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">规格型号</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">数量</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">单价</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">金额</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">备注</span>
              </td>
            </tr>
            <tr id="circulate">
              <td style="text-align: center">
                <span style="font-size: 16px">{$:序号}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:产品编号}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:产品名称}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:规格型号}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:下单数量}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:含税单价}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:含税总价}</span>
              </td>
              <td style="text-align: center">
                <span style="font-size: 16px">{$:备注}</span>
              </td>
            </tr>
            <tr>
              <td style="text-align: center">
                <span style="font-size: 16px">合计</span>
              </td>
              <td colspan="3">&nbsp;</td>
              <td style="text-align: center">
                <span style="font-size: 16px">{#:总数量}</span>
              </td>
              <td>&nbsp;</td>
              <td style="text-align: center">
                <span style="font-size: 16px">{#:金额}</span>
              </td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td style="text-align: center">
                <span style="font-size: 16px">金额(大写)</span>
              </td>
              <td style="text-align: center" colspan="7">
                <span style="font-size: 16px">{#:金额大写}</span>
              </td>
            </tr>
          </tbody>
        </table>`,
      old: false,
      sellList: [
        {
          key1: '1',
          key2: 'CP0001',
          key3: '1号螺丝',
          key4: '长:100/宽:20',
          key5: '100',
          key6: '10.5',
          key7: '105',
          key8: '备注测试1'
        },
        {
          key1: '2',
          key2: 'CP0002',
          key3: '2号螺丝',
          key4: '长:100/宽:30',
          key5: '200',
          key6: '10.5',
          key7: '205',
          key8: '备注测试2'
        },
        {
          key1: '3',
          key2: 'CP0003',
          key3: '3号螺丝',
          key4: '长:100/宽:40',
          key5: '300',
          key6: '10.5',
          key7: '305',
          key8: '备注测试3'
        }
      ],
      // 销售报价模板信息
      quotationSingleList: [
        { name: '报价人', value: 'baseQuotationPersonName' },
        { name: '电话', value: '' },
        { name: '邮箱', value: 'baseCustomerEmail' },
        { name: '地址', value: '' },
        { name: '客户名称', value: 'baseCustomerName' },
        { name: '客户电话', value: 'baseCustomerPhone' },
        { name: '制单人', value: 'creatorName' },
        { name: '客户地址', value: 'baseCustomerAddress' },
        { name: '联系人', value: 'baseCustomerContactsName' },
        { name: '日期', value: 'baseQuotationTime' },
        { name: '金额合计', value: 'valueTotalAmountWords' },
        { name: '小写金额', value: 'valueTotalAmountFigures' },
        { name: '交货时间', value: 'valueProduceDeliveryDate' },
        { name: '付款方式', value: 'valuePaymentModel' },
        { name: '运输方式', value: 'valueTransportModel' }
      ],
      quotationKeyList: [
        { name: '产品图片', value: 'baseImgUrl' },
        { name: '产品名称', value: 'baseMaterialName' },
        { name: '材料', value: '' },
        { name: '单位', value: 'baseMaterialUnitName' },
        { name: '数量', value: 'baseAmount' },
        { name: '单价', value: 'baseMaterialUnitprice' },
        { name: '金额', value: 'baseMaterialTotalprice' },
        { name: '备注', value: 'remark' }
      ],
      // 销售订单模板信息
      sellSingleList: [
        { name: '订单编号', value: '' },
        { name: '下单日期', value: '' },
        { name: '销售订单状态', value: '' },
        { name: '客户名称', value: '' },
        { name: '客户编号', value: '' },
        { name: '销售人', value: '' },
        { name: '总数量', value: '' },
        { name: '总金额', value: '' },
        { name: '金额大写', value: '' }
      ],
      sellKeyList: [
        { name: '序号', value: 'key1' },
        { name: '产品名称', value: 'key3' },
        { name: '产品编号', value: 'key2' },
        { name: '规格型号', value: 'key4' },
        { name: '产品类别', value: '' },
        { name: '产品单位', value: '' },
        { name: '下单数量', value: 'key5' },
        { name: '已出库数量', value: '' },
        { name: '含税单价', value: 'key6' },
        { name: '未税单价', value: '' },
        { name: '税率', value: '' },
        { name: '含税总价', value: 'key7' },
        { name: '未税总价', value: '' },
        { name: '账单金额', value: '' },
        { name: '已收金额', value: '' },
        { name: '未收金额', value: '' },
        { name: '已开票', value: '' },
        { name: '未开票', value: '' },
        { name: '交期', value: '' },
        { name: '备注', value: 'key8' }
      ],
      // 采购订单模板信息
      procureSingleList: [
        { name: '采购人', value: '' },
        { name: '电话', value: '' },
        { name: '邮箱', value: '' },
        { name: '原材料收货地址', value: '' },
        { name: '供应商名称', value: '' },
        { name: '供应商联系人', value: '' },
        { name: '供应商电话', value: '' },
        { name: '供应商地址', value: '' },
        { name: '联系人', value: '' },
        { name: '采购日期', value: '' }
      ],
      procureKeyList: [
        { name: '产品名称', value: '' },
        { name: '产品规格', value: '' },
        { name: '产品类型', value: '' },
        { name: '单位', value: '' },
        { name: '数量', value: '' },
        { name: '单价', value: '' },
        { name: '金额', value: '' },
        { name: '备注', value: '' }
      ],
      // 标准生产
      produceSingleList: [
        { name: '下单日期', value: '' },
        { name: '客户简称', value: '' },
        { name: '订单交期', value: '' },
        { name: '图片', value: '' },
        { name: '零件名称', value: '' },
        { name: '生产工序', value: '' },
        { name: '材料', value: '' },
        { name: '材料规格', value: '' },
        { name: '数量', value: '' },
        { name: '表面', value: '' },
        { name: '完成日期', value: '' },
        { name: '备注', value: '' }
      ],
      produceKeyList: [],
      // 销售出库单
      outboundKeyList: [
        { name: '序号', value: '' },
        { name: '产品名称', value: '' },
        { name: '单位', value: '' },
        { name: '数量', value: '' },
        { name: '备注', value: '' }
      ],
      outboundSingleList: [
        { name: '地址', value: '' },
        { name: '客户', value: '' },
        { name: '收货地址', value: '' },
        { name: '收货人', value: '' },
        { name: '电话', value: '' },
        { name: '出货时间', value: '' },
        { name: '订单对接人', value: '' },
        { name: '对接人电话', value: '' },
        { name: '仓库', value: '' },
        { name: '质检', value: '' },
        { name: '发货', value: '' }
      ],
      // 页面显示的打印变量
      printSingleList: [],
      printKeyList: [],
      // 选中的模板
      singleData: {},
      // 单个打印模板集合
      list: [],
      // 当前状态 1:新增，2修改
      detailsType: 0,
      // 显示详情还是列表
      detailsStatus: 1,
      // 树节点信息--------------------
      defaultExpandKeys: [2],
      treeList: treeList.treeList,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 当前选中的树节点
      treeNode: { id: 21, modules: 21, label: '销售报价', children: [] },
      // --------------------
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      // -------------
      print: {
        id: 'printArea', // 打印的区域的id名
        popTitle: '', // 打印配置页上方标题
        extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        extraCss: ''
      }
    };
  },
  created() {
    this.getList();
    this.handleNodeClick(this.treeNode);
    var str = '{\"panels\":[{\"index\":0,\"name\":1,\"height\":139,\"width\":241,\"paperHeader\":0,\"paperFooter\":394.0157480314961,\"printElements\":[{\"options\":{\"left\":157.5,\"top\":57,\"height\":69,\"width\":67,\"src\":\"https://src.qingguangtech.com/application/1693909426487951447/qingguang/attachment/68dacb8058664f0f8184664d9a7c5b12.jpg\",\"fit\":\"\",\"coordinateSync\":false,\"widthHeightSync\":false,\"right\":224.5,\"bottom\":127.5,\"vCenter\":191,\"hCenter\":93},\"printElementType\":{\"title\":\"Logo\",\"type\":\"image\"}},{\"options\":{\"left\":195,\"top\":58.5,\"height\":17,\"width\":282,\"testData\":\"单据表头\",\"fontSize\":16.5,\"fontWeight\":\"700\",\"textAlign\":\"center\",\"hideTitle\":true,\"title\":\"威榕传动系统(上海)有限公司\",\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0,\"right\":477,\"bottom\":75.5,\"vCenter\":336,\"hCenter\":67},\"printElementType\":{\"title\":\"单据表头\",\"type\":\"text\"}},{\"options\":{\"left\":204,\"top\":84,\"height\":17,\"width\":316.5,\"testData\":\"单据表头\",\"fontSize\":15,\"textAlign\":\"center\",\"hideTitle\":true,\"title\":\"地址:上海市嘉定区南翔镇科盛路610号3楼\",\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0,\"right\":546,\"bottom\":101,\"vCenter\":387.75,\"hCenter\":92.5},\"printElementType\":{\"title\":\"单据表头\",\"type\":\"text\"}},{\"options\":{\"left\":219,\"top\":105,\"height\":17,\"width\":214.5,\"testData\":\"单据表头\",\"fontSize\":15,\"textAlign\":\"center\",\"hideTitle\":true,\"title\":\"电话:021-59102920\",\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0,\"right\":432.75,\"bottom\":121.25,\"vCenter\":325.5,\"hCenter\":112.75},\"printElementType\":{\"title\":\"单据表头\",\"type\":\"text\"}},{\"options\":{\"left\":259.5,\"top\":126,\"height\":17,\"width\":120,\"testData\":\"单据表头\",\"fontSize\":16.5,\"fontWeight\":\"700\",\"textAlign\":\"center\",\"hideTitle\":true,\"title\":\"销售出库单\",\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0,\"right\":379.5,\"bottom\":143,\"vCenter\":319.5,\"hCenter\":134.5},\"printElementType\":{\"title\":\"单据表头\",\"type\":\"text\"}},{\"options\":{\"left\":376.5,\"top\":159,\"height\":16,\"width\":120,\"field\":\"salesDeliveryDocNumber\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"出库单号\",\"right\":497.25,\"bottom\":175,\"vCenter\":437.25,\"hCenter\":167,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":97.5,\"top\":160.5,\"height\":16,\"width\":120,\"field\":\"baseCustomerName\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"客户名称\",\"right\":217.5,\"bottom\":176.5,\"vCenter\":157.5,\"hCenter\":168.5,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":376.5,\"top\":180,\"height\":16,\"width\":120,\"field\":\"baseExportHomeTime\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"出库日期\",\"right\":495.75,\"bottom\":195.25,\"vCenter\":435.75,\"hCenter\":187.25,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":97.5,\"top\":181.5,\"height\":16,\"width\":120,\"field\":\"customerShippinginfoUserName\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"收货人\",\"right\":216,\"bottom\":197.5,\"vCenter\":156,\"hCenter\":189.5,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":97.5,\"top\":201,\"height\":16,\"width\":120,\"field\":\"customerShippinginfoUserPhone\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"联系方式\",\"right\":238.5,\"bottom\":228.25,\"vCenter\":178.5,\"hCenter\":220.25,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":378,\"top\":201,\"height\":16,\"width\":120,\"field\":\"baseSalespersonName\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"客户经理\",\"right\":494.25,\"bottom\":219.25,\"vCenter\":434.25,\"hCenter\":211.25,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":97.5,\"top\":223.5,\"height\":16,\"width\":120,\"field\":\"customerShippinginfoUserAddress\",\"testData\":\"高级客户\",\"fontSize\":12,\"fontWeight\":\"lighter\",\"textContentVerticalAlign\":\"middle\",\"title\":\"收货地址\",\"right\":216,\"bottom\":238.75,\"vCenter\":156,\"hCenter\":230.75,\"coordinateSync\":false,\"widthHeightSync\":false,\"qrCodeLevel\":0},\"printElementType\":{\"title\":\"客户名称\",\"type\":\"text\"}},{\"options\":{\"left\":39,\"top\":250.5,\"height\":543,\"width\":550,\"fields\":[{\"text\":\"名称\",\"field\":\"NAME\"},{\"text\":\"数量\",\"field\":\"SL\"},{\"text\":\"规格\",\"field\":\"GG\"},{\"text\":\"条码\",\"field\":\"TM\"},{\"text\":\"单价\",\"field\":\"DJ\"},{\"text\":\"金额\",\"field\":\"JE\"},{\"text\":\"备注\",\"field\":\"DETAIL\"}],\"field\":\"salesDeliveryDocDetailList\",\"footerFormatter\":\"function(t,e,i,l){return i&&i[\\\"totalCap\\\"]?\'<td style=\\\"padding:0 10px\\\" colspan=\\\"100\\\">\'.concat(\\\"出库备注: \\\"+i[\\\"totalCap\\\"],\\\"</td>\\\"):\'<td style=\\\"padding:0 10px\\\" colspan=\\\"100\\\">出库备注: </td>\'}\",\"coordinateSync\":false,\"widthHeightSync\":false,\"right\":589,\"bottom\":304.5,\"vCenter\":314,\"hCenter\":277.5,\"columns\":[[{\"width\":91.66666666666667,\"title\":\"客户订单号\",\"field\":\"NAME\",\"checked\":true,\"columnId\":\"NAME\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":91.66666666666667,\"title\":\"客户料号\",\"field\":\"SL\",\"checked\":true,\"columnId\":\"SL\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":91.66666666666667,\"title\":\"产品名称\",\"field\":\"TM\",\"checked\":true,\"columnId\":\"TM\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":91.66666666666667,\"title\":\"物料编码\",\"field\":\"GG\",\"checked\":true,\"columnId\":\"GG\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":91.66666666666667,\"title\":\"规格/型号\",\"field\":\"DJ\",\"checked\":true,\"columnId\":\"DJ\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":91.66666666666667,\"title\":\"数量\",\"field\":\"JE\",\"checked\":true,\"columnId\":\"JE\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\",\"tableQRCodeLevel\":0,\"tableSummaryTitle\":true,\"tableSummary\":\"\"},{\"width\":100,\"title\":\"备注\",\"field\":\"DETAIL\",\"checked\":false,\"columnId\":\"DETAIL\",\"fixed\":false,\"rowspan\":1,\"colspan\":1,\"align\":\"center\"}]]},\"printElementType\":{\"title\":\"订单数据\",\"type\":\"table\",\"editable\":true,\"columnDisplayEditable\":true,\"columnDisplayIndexEditable\":true,\"columnTitleEditable\":true,\"columnResizable\":true,\"columnAlignEditable\":true,\"isEnableEditField\":true,\"isEnableContextMenu\":true,\"isEnableInsertRow\":true,\"isEnableDeleteRow\":true,\"isEnableInsertColumn\":true,\"isEnableDeleteColumn\":true,\"isEnableMergeCell\":true}}],\"paperNumberLeft\":364,\"paperNumberTop\":372,\"paperNumberContinue\":true,\"rotate\":true,\"watermarkOptions\":{}}]}';
  },
  methods: {
    dayin() {
      this.$nextTick(() => {
        this.$refs.easyPrint.print();
      });
    },
    getList() {
      sysPrint_list({
        sysPrintDtoFilter: { modules: this.treeNode.modules },
        pageParam: this.listQuery
      }).then((res) => {
        this.list = res.data.data.dataList;
      });
    },
    delModule(e) {
      this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sysPrint_delete({ sysPrintId: e.sysPrintId }).then((res) => {
          this.$message.success('删除成功！')
          this.getList();
        })
      })
    },
    handleNodeClick(data, node) {
      switch (data.modules) {
        case 21:
          this.printKeyList = this.quotationKeyList;
          this.printSingleList = this.quotationSingleList;
          break;
        case 22:
          this.printKeyList = this.sellKeyList;
          this.printSingleList = this.sellSingleList;
          break;
        case 23:
          this.printKeyList = this.outboundKeyList;
          this.printSingleList = this.outboundSingleList;
  
          break;
        case 31:
          this.printKeyList = this.procureKeyList;
          this.printSingleList = this.procureSingleList;
          break;
        case 41:
          this.printKeyList = this.produceKeyList;
          this.printSingleList = this.produceSingleList;
          break;
        default:
          this.printKeyList = [];
          this.printSingleList = [];
          break;
      }
      if (data.modules != 0) {
        this.treeNode = data;
        this.detailsStatus = 1;
        this.singleData = {};
        this.getList();
      }
    },
    detailsGo(row) {
      var isOld = row.printTemplateDetails.includes('printTable');
      if (isOld) {
        this.singleData = row;
        this.detailsStatus = 2;
        this.detailsType = 2;
      } else {
        this.$router.push({
          path: '/main/print_printSystem',
          query: { singleData: row, treeNode: this.treeNode, detailsType: 2 }
        });
      }
    },
    saveRowData(row) {
      sysPrint_setDefault({
        modules: row.modules,
        sysPrintId: row.sysPrintId
      }).then((res) => {
        this.$message.success('操作成功！');
        this.getList();
      });
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    add() {
      if (this.old) {
        this.singleData = {};
        this.detailsStatus = 2;
        this.detailsType = 1;
      } else {
        this.$router.push({
          path: '/main/print_printSystem',
          query: { singleData: {}, treeNode: this.treeNode, detailsType: 1 }
        });
      }
    },
    saveClick() {
      if (this.detailsType == 1) {
        let json = {
          sysPrintId: this.singleData.sysPrintId,
          modules: this.treeNode.modules,
          orderNum: this.singleData.orderNum,
          printTemplateDetails: this.singleData.printTemplateDetails,
          printTimes: 0,
          remark: this.singleData.remark,
          sysPrintName: this.singleData.sysPrintName,
          sysPrintType: this.singleData.sysPrintType,
          isDefault: 1
        };
        sysPrint_add({ sysPrintDto: json }).then((res) => {
          this.$message.success('操作成功！');
          this.getList();
          this.detailsStatus = 1;
          this.detailsType = 0;
          this.singleData = {};
        });
      } else {
        let json = {
          sysPrintId: this.singleData.sysPrintId,
          modules: this.treeNode.modules,
          orderNum: this.singleData.orderNum,
          printTemplateDetails: this.singleData.printTemplateDetails,
          printTimes: this.singleData.printTimes,
          remark: this.singleData.remark,
          sysPrintName: this.singleData.sysPrintName,
          sysPrintType: this.singleData.sysPrintType,
          isDefault: this.singleData.isDefault
        };
        sysPrint_update({ sysPrintDto: json }).then((res) => {
          this.$message.success('操作成功！');
          this.getList();
          this.detailsStatus = 1;
          this.detailsType = 0;
          this.singleData = {};
        });
      }
    }
  }
};
</script>
  <style lang="less" scoped>
  // 拖拽
  .drag_item_box {
    height: 100%;
    padding: 6px;
  }
  
  .spanBtn {
    color: #08a1b8;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    padding: 0px 5px;
  }
  
  /* ---------------- */
  .table {
    width: 100%;
    margin: 0 auto;
    table-layout: fixed;
    word-wrap: break-word;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #b7c0c9;
  }
  
  .table td {
    height: 36px;
    background-color: #fff;
    border: 1px solid #b7c0c9;
    color: black;
    text-align: left;
    padding: 5px 5px;
  }
  
  .tableTitle {
    width: 240px !important;
    background-color: #f8f8f8 !important;
  }
  
  .tableTitle div {
    text-align: center;
  }
  
  ::v-deep .el-descriptions__table {
    background-color: transparent !important
  }
  </style>
